import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, OtherWorkType, OtherWorkTypeWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateOtherWorkType(): UseMutationResult<
  AxiosResponse<OtherWorkType>,
  AxiosError<ErrorMessage>,
  OtherWorkTypeWrite
> {
  const queryClient = useQueryClient();

  const updateOtherWorkType = (otherWorkType: OtherWorkTypeWrite): Promise<AxiosResponse<OtherWorkType>> => {
    return client.put(`other-work-types/${otherWorkType?.otherWorkTypeId}/`, otherWorkType);
  };

  return useMutation(updateOtherWorkType, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['otherWorkTypes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['otherWorkPayRateLookups'],
      });
    },
  });
}
